import { createSelector } from "@reduxjs/toolkit";
import {
  selectDraftComponentIds,
  selectEditorMode,
} from "@v1/reducers/core-reducer";
import { selectIsRightBarAnalyticsOpen } from "@v1/reducers/ui-reducer";

export const selectIsRightBarVisible = createSelector(
  selectEditorMode,
  selectIsRightBarAnalyticsOpen,
  selectDraftComponentIds,
  (editorMode, isRightBarAnalyticsOpen, draftComponentIds) => {
    return (
      (editorMode === "edit" || editorMode === "aiGeneration") &&
      (draftComponentIds.length > 0 || isRightBarAnalyticsOpen)
    );
  },
);
